import { LotCompactionLevelItem } from './LotCompactionLevelItem'
import { LotMessageOptions, TestMessageOptions } from './types'

export const Lot = new LotCompactionLevelItem({
  id: '0E6E5FFE-EFAF-4F3E-A263-5B8F8F352823',
  label: 'Lot',
  description:
    "If the Average Compaction of the Lot is less than the Material Requirement's Lot Compaction Requirement, issue an Identified Field Issue using the Message. Messages will always be followed by the actual and expected values.",
  levelMessage: ({ message, actual, expected }: LotMessageOptions) =>
    `${message}. Actual: ${actual}, Expected: ${expected}`,
})

export const Test = new LotCompactionLevelItem({
  id: 'E458710A-A711-49D5-902E-15CD25E55758',
  label: 'Test',
  description:
    "If the Average Percent of one or more Density Tests associated with the Lot is less than the Material Requirement's Lot Compaction Requirement, issue an Identified Field Issue using the Message. Messages will always be followed by the actual and expected values.",
  levelMessage: ({ message, expected, failed }: TestMessageOptions) => {
    const resolved = Array.isArray(failed) ? failed : [failed]
    return `${message}. ${resolved
      .map(
        ({ testId, actual }) =>
          `Test ID: ${
            testId ?? 'N/A'
          }, Actual: ${actual}, Expected: ${expected}`
      )
      .join('. ')}`
  },
})
